/* eslint-disable */
import { MODULE_NAME, } from './../constants';

export const all = state => state[MODULE_NAME];
export const reduxForm = state => state[MODULE_NAME].reduxFormReducer;
